import * as React from "react";

import { ArrayFieldSchema, OtherFieldSchema } from "@generation/core/src/Schema/Fields";
import { useFlexDirectionFormGroupContext } from "@generation/form";
import { useDataContext, getNumberOfItemsInArray } from "@generation/overview-core";

import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { RenderFieldSchemaComponent, RenderFields } from "../Read/RenderFields";

interface ArrayFieldProps {
  field: ArrayFieldSchema;
  name: string;
}

export const ArrayField = (
  renderAddedSchemaFields?: (name: string, field: OtherFieldSchema) => RenderFieldSchemaComponent
) =>
  withHideOnFieldHoc((props: ArrayFieldProps): JSX.Element => {
    const items = Array.from(new Array(getNumberOfItemsInArray(useDataContext(), props.name)), (_x, i) => i);

    const showTitle = props.field.ui?.showTitle ? (
      <div className="read-item__label">{props.field.label}</div>
    ) : (
      <></>
    );

    if (props.field.ui?.isNumberedList && items.length > 0) {
      const flexDirectionFormGroupControlContext = useFlexDirectionFormGroupContext();
      const flexDirection =
        props.field.ui?.readOverview?.flexDirection ??
        props.field.ui?.flexDirection ??
        flexDirectionFormGroupControlContext;

      return (
        <div className={`read_item flexdirection-${flexDirection}`} id={props.name}>
          {showTitle}
          <ol className="read-list">
            {items.map((item) => (
              <React.Fragment key={`${props.name}.${item}`}>
                <RenderFields
                  field={props.field.items}
                  name={`${props.name}[${item}]`}
                  renderAddedSchemaFields={renderAddedSchemaFields}
                />
              </React.Fragment>
            ))}
          </ol>
        </div>
      );
    }

    return (
      <>
        {showTitle}
        {items.map((item) => (
          <div
            className="array-field-read-item fieldset-subset fieldset-container__read-items"
            key={`${props.name}.${item}`}
          >
            <RenderFields field={props.field.items} name={`${props.name}[${item}]`} />
          </div>
        ))}
      </>
    );
  });
